/**
 * The screen sizes the website uses for responsive design
 */
export const ScreenSizes = {
  Desktop: 972,
  UnderDesktop: 971,
  Tablet: 720
}